import { first, uniq, without } from 'lodash'
import React from 'react'

const useBuilder = ({
    onBuilt = () => {}
} = {}) => {
    const [ records, updateRecords ] = React.useState([])
    const [ columns, setColumns ] = React.useState([])
    const [ selectedRecords, setSelectedRecords ] = React.useState([])

    React.useEffect(() => {
        if (records.length) {
            setColumns(first(records).map(r => ''))
            setSelectedRecords(records.map((v, i) => i))
        } else {
            setColumns([])
        }
    }, [records])

    React.useEffect(() => {
        const results = []
        if (columns.length && selectedRecords.length) {
            records.forEach((recordColumns, recordIndex) => {
                const record = {}
                columns.forEach((columnName, columnIndex) => {
                    if (columnName) {
                        record[columnName] = recordColumns[columnIndex]
                    }
                })
                if (Object.keys(record).length && selectedRecords.includes(recordIndex)) {
                    results.push(record)
                }
            })
        }
        onBuilt(results)
    }, [columns, selectedRecords, onBuilt, records])

    const toggleRow = React.useCallback((index, value) => {
        if (!value) {
            setSelectedRecords(without(selectedRecords, index))
        } else {
            setSelectedRecords(uniq([...selectedRecords, index]))
        }
    }, [selectedRecords, setSelectedRecords])

    const toggleAll = React.useCallback((value) => {
        if (value) {
            setSelectedRecords(records.map((v, i) => i))
        } else {
            setSelectedRecords([])
        }
    }, [setSelectedRecords, records])

    const setColumn = React.useCallback((index, value) => {
        setColumns(columns.map((v, i) => i === index ? value : v))
    }, [columns, setColumns])

    const setRecords = React.useCallback((records) => {
        //  Remove empty records
        records = records.filter(r => r.some(v => v))
        updateRecords(records)
    }, [updateRecords])

    return {
        records,
        setRecords,
        toggleRow,
        columns,
        setColumn,
        toggleRow,
        selectedRecords,
        toggleAll
    }
}

export default useBuilder
